import template from './involvedPartyRows.html';

export default {
  template,
  bindings: {
    onOpenEditClientModal: '&',
    onOpenDeleteClientModal: '&',
    onToggleOtherInfo: '&',
    onViewContact: '&',
    clientList: '<',
    isEnableDeleteParty: '<',
  },
};
